module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.d0884059.ttf";